export const INVITATIONS_INPUT = 'INVITATIONS_INPUT' as const;
export const INVITATIONS_OUTPUT = 'INVITATIONS_OUTPUT' as const;
